import { render, staticRenderFns } from "./StudentEvaluationHistory.vue?vue&type=template&id=0958f1df&scoped=true"
import script from "./StudentEvaluationHistory.vue?vue&type=script&lang=js"
export * from "./StudentEvaluationHistory.vue?vue&type=script&lang=js"
import style0 from "./StudentEvaluationHistory.vue?vue&type=style&index=0&id=0958f1df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0958f1df",
  null
  
)

export default component.exports